import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';
import { EditProfileDto } from '../../../dto/editprofile/editprofiledto';

export interface EditProfileRequest extends APIRequest
{
    getEditProfileRequest(): EditProfileDto;
}

export class EditProfileRequestImpl extends APIRequestDtoImpl implements EditProfileRequest
{
    constructor(private editProfileData: EditProfileDto)
    {
        super();
    }

    getEditProfileRequest(): EditProfileDto
    {
        return this.editProfileData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/myaccount/editprofile/editprofilerequest.tsx